import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Button,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap";

import { Formik, Form, ErrorMessage, Field } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { apiGet, apiPost, apiPut, apiDelete } from "helpers/apiService";
import SafeField from "helpers/SafeField";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";

const Currency = () => {
  const [currencies, setCurrencies] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selected, setSelected] = useState({});

  useEffect(() => {
    fetchCurrencies();
  }, []);

  const toggle = () => setIsOpen(!isOpen);

  const fetchCurrencies = () => {
    apiGet("Currency/all")
      .then(res => setCurrencies(res.data))
      .catch(err => console.error(err));
  };

  /* ================= CREATE ================= */

  const handleCreate = (values, { setSubmitting, resetForm }) => {
    toast.loading("Saving...");

    apiPost("Currency", values)
      .then(res => {
        toast.dismiss();
        if (res.data?.success !== false) {
          toast.success("Saved Successfully");
          fetchCurrencies();
          resetForm();
        } else {
          toast.error("Save failed");
        }
      })
      .catch(() => {
        toast.dismiss();
        toast.error("Something went wrong");
      })
      .finally(() => setSubmitting(false));
  };

  /* ================= UPDATE ================= */

  const handleUpdate = (values, { setSubmitting }) => {
    toast.loading("Updating...");

    apiPut("Currency", values)
      .then(res => {
        toast.dismiss();
        if (res.data?.success !== false) {
          toast.success("Updated ");
          fetchCurrencies();
          toggle();
        } else {
          toast.error("Update failed");
        }
      })
      .catch(() => {
        toast.dismiss();
        toast.error("Something went wrong");
      })
      .finally(() => setSubmitting(false));
  };

  /* ================= DELETE ================= */

  const handleDelete = id => {
    Swal.fire({
      title: "Are you sure?",
      text: "Currency will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then(result => {
      if (!result.isConfirmed) return;

      apiDelete(`Currency/${id}`)
        .then(() => {
          toast.success("Deleted Successfully");
          fetchCurrencies();
        })
        .catch(() => toast.error("Delete failed"));
    });
  };

  const openEdit = item => {
    setSelected(item);
    setIsEdit(true);
    toggle();
  };

  /* ================= VALIDATION ================= */

  const validationSchema = Yup.object({
    currencyTitle: Yup.string().required("Required"),
    currencyCode: Yup.string().required("Required"),
    currenciesymbol: Yup.string().required("Required"),
  });

  return (
    <Container fluid className="page-content">
      <ToastContainer autoClose={2000} />
        <Row className="mb20">
                    <Col xl="12">
                      <Breadcrumbs title="General Settings" breadcrumbItem="Currency" />
                    </Col>
                  </Row>
        
      <Row>
        <Col xl="12">
          <Card>
            <CardBody>
             

              {/* ===== CREATE FORM ===== */}
              <Formik
                initialValues={{
                  currencyTitle: "",
                  currencyCode: "",
                  currenciesymbol: "",
                  currencyFlagClass: "",
                  agentId: parseInt(localStorage.getItem("userId")) || 0,
                  isActive: true,
                }}
                validationSchema={validationSchema}
                onSubmit={handleCreate}
              >
                {({ errors, touched, handleChange }) => (
                  <Form>
                    <Row>
                      <Col md="3">
                        <FormGroup>
                          <Label>Title *</Label>
                          <SafeField
                            name="currencyTitle"
                            onChange={handleChange}
                            className={`form-control ${
                              errors.currencyTitle && touched.currencyTitle ? "is-invalid" : ""
                            }`}
                          />
                          <ErrorMessage name="currencyTitle" component="div" className="invalid-feedback" />
                        </FormGroup>
                      </Col>

                      <Col md="2">
                        <FormGroup>
                          <Label>Code *</Label>
                          <SafeField
                            name="currencyCode"
                            onChange={handleChange}
                            className={`form-control ${
                              errors.currencyCode && touched.currencyCode ? "is-invalid" : ""
                            }`}
                          />
                        </FormGroup>
                      </Col>

                      <Col md="2">
                        <FormGroup>
                          <Label>Symbol *</Label>
                          <SafeField
                            name="currenciesymbol"
                            onChange={handleChange}
                            className={`form-control ${
                              errors.currenciesymbol && touched.currenciesymbol ? "is-invalid" : ""
                            }`}
                          />
                        </FormGroup>
                      </Col>

                      <Col md="3">
                        <FormGroup>
                          <Label>Flag Class</Label>
                          <SafeField
                            name="currencyFlagClass"
                            onChange={handleChange}
                            className="form-control"
                          />
                        </FormGroup>
                      </Col>

                      <Col md="2" className="d-flex align-items-end">
                        <Button type="submit" color="primary">
                          Save
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </CardBody>
          </Card>

          {/* ===== LIST ===== */}
          <Card>
            <CardBody>
              <h5>Currency List</h5>

              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Title</th>
                      <th>Code</th>
                      <th>Symbol</th>
                      <th>Flag</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currencies.map((c, i) => (
                      <tr key={c.currencyId || i}>
                        <td>{i + 1}</td>
                        <td>{c.currencyTitle}</td>
                        <td>{c.currencyCode}</td>
                        <td>{c.currenciesymbol}</td>
                        <td>{c.currencyFlagClass}</td>
                        <td>{c.isActive ? "Active" : "Inactive"}</td>
                        <td>
                             <ActionEdit onClick={() => openEdit(c)} />
                            <ActionDelete onClick={() => handleDelete(c.currencyId)} />
                         
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* ===== EDIT OFFCANVAS ===== */}
      <Offcanvas isOpen={isOpen} toggle={toggle} direction="end">
        <OffcanvasHeader toggle={toggle}>Update Currency</OffcanvasHeader>
        <OffcanvasBody>
          <Formik
            enableReinitialize
            initialValues={selected}
            validationSchema={validationSchema}
            onSubmit={handleUpdate}
          >
            {({ errors, touched, handleChange }) => (
              <Form>
                <FormGroup>
                  <Label>Title *</Label>
                  <SafeField name="currencyTitle" onChange={handleChange} className="form-control" />
                </FormGroup>

                <FormGroup>
                  <Label>Code *</Label>
                  <SafeField name="currencyCode" onChange={handleChange} className="form-control" />
                </FormGroup>

                <FormGroup>
                  <Label>Symbol *</Label>
                  <SafeField name="currenciesymbol" onChange={handleChange} className="form-control" />
                </FormGroup>

                <FormGroup>
                  <Label>Flag Class</Label>
                  <SafeField name="currencyFlagClass" onChange={handleChange} className="form-control" />
                </FormGroup>

                <FormGroup check className="mb-3">
                  <Field type="checkbox" name="isActive" />
                  <Label check className="ms-2">Active</Label>
                </FormGroup>

                <Button type="submit" color="primary">
                  Update
                </Button>
              </Form>
            )}
          </Formik>
        </OffcanvasBody>
      </Offcanvas>
    </Container>
  );
};

export default Currency;
